import { Venue } from '../app/App.types'

interface Props {
  venue?: Pick<Venue, 'name' | 'logo'>
  company: {
    venues: Array<{ id: string }>
    widgetBrandSettings: {
      displayName?: string | null
      logo?: { xSmall?: string } | null
    }
  }
}

interface HeaderBranding {
  headerName: string
  headerLogoSrc: string | undefined
  isMultiVenue: boolean
}

/**
 * Determines header branding (name and logo) based on whether the venue
 * is part of a multi-venue company.
 *
 * For multi-venue companies: Uses company widget brand settings
 * For single-venue companies: Uses venue's own name and logo
 */
export function getHeaderBranding({ venue, company }: Props): HeaderBranding {
  const isMultiVenue = company.venues.length > 1

  const headerName = isMultiVenue
    ? company.widgetBrandSettings.displayName
    : !venue // This could happen if it's a test
      ? company.widgetBrandSettings.displayName
      : venue.name

  const headerLogoSrc = isMultiVenue
    ? company.widgetBrandSettings.logo?.xSmall || venue?.logo?.xSmall
    : venue?.logo?.xSmall

  return {
    headerName: headerName || '',
    headerLogoSrc,
    isMultiVenue,
  }
}
